/* Component Dependencies */
var messageBoxTemplate = require('templates/messageBox.hbs');
var messageBoxTemplateCheckInConfirmation = require('messageBox-checkInConfirmation.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'messageBox',

  template: {
    'messageBox': messageBoxTemplate,
    'messageBox-checkInConfirmation': messageBoxTemplateCheckInConfirmation
  },

  subscribe: {
    'REFRESH_MESSAGE_BOX': 'refreshMessageBox'
  },

  bindEvents: function(jquery) {
    if($('.js-res-link-enroll-div').length && window.location.pathname === "/loyalty/findReservationList.mi"){
      var _self = this;
      $(_self.$el.find('.message-items a')).on('click', _self.resLookUpModal.bind(_self));
    }
  },

 /**
  * This function looks up reservation modal on click of the reservation link 
  * in the enroll error/success message
  * @param {String} event
  */
  resLookUpModal: function _resLookUpModal(event) {
    event.preventDefault();
    var $searchReservationLink = $(".search-reservation");     
    $searchReservationLink.trigger('click');
  },
  /**
  * This function checks if the message identifer published is for this message box or not
  * and refreshes this message box if the message identifier is for itself
  * @param {String} Message identifier specific to this message box
  * @returns {Boolean} Returns true if message box has refreshed itself, false otherwise
  */
  refreshMessageBox: function _refreshMessageBox(messageIdentifier, updatePageURI) {
    if (this.$el.data('message-identifier') === messageIdentifier) {
      var context = {
        pageURI: ""
      };
      this.refresh(updatePageURI ? context : undefined);
      return true;
    }
    return false;
  },

  /**
  * This function sets focus on the message box when it is displayed
  * @returns {Boolean} Returns true if message box has refreshed itself, false otherwise
  */
  afterComponentRefresh: function _afterComponentRefresh() {
    if (this.$el.data('showMessage')) {
      this.$el.focus();
    }
    return true;
  }
});
